import React from 'react'
import { Label, type LabelProps } from '@/ui/atoms/Label'

export type ValuePropItem = {
  value: string
  label: string
  variant?: LabelProps['variant']
}

export type ValuePropsProps = {
  items: ValuePropItem[]
  className?: string
}

export const ValueProps: React.FC<ValuePropsProps> = ({ items, className = '' }) => {
  return (
    <div className={`w-full ${className}`}>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
        {items.map((item, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center rounded-lg border border-border-subtle bg-white p-5 transition-all duration-200 canhover:hover:border-border-base canhover:hover:shadow-sm lg:p-8"
          >
            <div className="mb-5 text-center text-headline-L-semibold leading-none tracking-tight text-text-base">
              {item.value}
            </div>
            <Label variant={item.variant || 'transparent'} size="medium" title={item.label} />
          </div>
        ))}
      </div>
    </div>
  )
}
